var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8LinkedinFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.113,
    height: 15.113,
    viewBox: "0 0 15.113 15.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e4e4e4;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_linkedin_1",
    className: "cls-1",
    d: "M8.309,6A2.319,2.319,0,0,0,6,8.309V18.8a2.319,2.319,0,0,0,2.309,2.309H18.8A2.319,2.319,0,0,0,21.113,18.8V8.309A2.319,2.319,0,0,0,18.8,6Zm0,1.259H18.8a1.04,1.04,0,0,1,1.05,1.05V18.8a1.04,1.04,0,0,1-1.05,1.05H8.309a1.04,1.04,0,0,1-1.05-1.05V8.309A1.04,1.04,0,0,1,8.309,7.259ZM9.988,8.939a1.05,1.05,0,1,0,1.05,1.05,1.05,1.05,0,0,0-1.05-1.05Zm-.63,2.939a.419.419,0,0,0-.42.42v5.458a.419.419,0,0,0,.42.42h1.259a.419.419,0,0,0,.42-.42V12.3a.419.419,0,0,0-.42-.42Zm2.939,0a.419.419,0,0,0-.42.42v5.458a.419.419,0,0,0,.42.42h1.259a.419.419,0,0,0,.42-.42V14.606a1.05,1.05,0,0,1,2.1,0v3.149a.419.419,0,0,0,.42.42h1.259a.419.419,0,0,0,.42-.42V14.4a2.514,2.514,0,0,0-4.2-1.872V12.3a.419.419,0,0,0-.42-.42Z",
    transform: "translate(-6 -6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8LinkedinFooter);
export default __webpack_public_path__ + "static/media/icons8_linkedin_Footer.9790897b29ec9d4e8dfcfe91fd750ab9.svg";
export { ForwardRef as ReactComponent };